































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import OzButton from 'library/v4/components/OzButton.vue'

@Component({ components: { OzButton } })
export default class CollectionListItem extends Mixins() {
  @(namespace('browser').Getter) isPhone!: boolean
  @Prop({ default: 'normal' }) titleFontWeight!: 'strong' | 'normal'
  @Prop({ default: false }) expandFullWidth!: boolean
  @Prop() leftTitle!: string
  @Prop() leftSubtitle!: string
  @Prop() midTitle!: string
  @Prop() midSubtitle!: string
  @Prop() buttonText!: string
  @Prop() iconName!: string
  @Prop() url?: string

  get isBoldTitle(): boolean {
    return this.titleFontWeight === 'strong'
  }

  click(): void {
    this.$emit('click')
  }
}
